const APPLE_PLATFORM_PATTERN = /Mac|iPhone|iPad|iPod/i;

const isApplePlatform = (): boolean => {
  const platform =
    typeof navigator === "undefined"
      ? ""
      : `${navigator.platform} ${navigator.userAgent}`;
  return APPLE_PLATFORM_PATTERN.test(platform);
};

// NOTE: "⌘K" on Apple platforms, "Ctrl+K" elsewhere — the key the palette's
// shortcut actually listens for on this machine.
export const getSearchShortcutLabel = (): string =>
  isApplePlatform() ? "⌘K" : "Ctrl+K";

// NOTE: NSAI-6853 — the same shortcut as printed on the header's keycap:
// "⌘K" on macOS / iOS, "Ctrl K" on Windows and Linux.
export const getSearchShortcutKeycap = (): string =>
  isApplePlatform() ? "⌘K" : "Ctrl K";
